import { Coord } from "../../../../types/Interface";
import getAngleBetweenPoints from "../../../../utils/math/getAngleBtwPoints";
import getDistanceBtwPoints from "../../../../utils/getDistanceBtwPoints";


export default function limitDistance(startCoord: Coord, newEndCoord: Coord, totalH: number): Coord {
  const max = 1.7 * totalH;
  const min = 108;
  const distance = getDistanceBtwPoints(startCoord, newEndCoord);

  if(distance > max) {
    return getFollowerCoord(startCoord, newEndCoord, max);
  } else if(distance < min) {
    return getFollowerCoord(startCoord, newEndCoord, min);
  }
  return newEndCoord
}


function getFollowerCoord(startCoord: Coord,  newEndCoord: Coord, distance: number){
  const rad = getAngleBetweenPoints(startCoord, newEndCoord);
  const eCoord = {
    x: Math.floor(startCoord.x + Math.cos(rad) * distance),
    y: Math.floor(startCoord.y + Math.sin(rad) * distance)
  }
  return eCoord
}